import { ApolloCache } from "@apollo/client";
import { CastStopMutation } from "src/types.g";

type StoppedScreens = NonNullable<
  NonNullable<CastStopMutation["castStop"]>["screens"]
>;

interface ClearStoppedCastOptions {
  castId: string;
  screens: StoppedScreens;
}

/**
 * Applies a castStop result to the cache instead of refetching each screen.
 * `castId` is already nulled by the response itself; this clears the
 * `castByCastId` ref the response doesn't select, and evicts the Cast so it
 * drops out of any cast list (dangling list refs are filtered on read).
 */
export const clearStoppedCast = (
  cache: ApolloCache<unknown>,
  { castId, screens }: ClearStoppedCastOptions,
) => {
  screens.forEach((screen) => {
    cache.modify({
      id: cache.identify(screen),
      fields: { castByCastId: () => null },
    });
  });
  cache.evict({ id: cache.identify({ __typename: "Cast", id: castId }) });
};
